export default {
    transform() {
        return (data) =>
            JSON.parse(data).map((option) => ({
                value: option.id,
                label: `${option.name} (${option.city}, ${option.state})`,
                data: option,
            }))
    },
}
